var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-stepper",
    { staticClass: "pa-0", attrs: { elevation: "0" } },
    [
      _c(
        "v-stepper-header",
        [
          _vm._l(_vm.values, function (value, i) {
            return [
              _c(
                "v-stepper-step",
                {
                  key: i,
                  attrs: {
                    complete: _vm.markComplete(i),
                    step: value.text,
                    color: "secondary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.update(value, i)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(value.text) + " ")]
              ),
              _vm.values.indexOf(value) != _vm.values.length - 1
                ? _c("v-divider", { key: value.text })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }